
export const URLPago = "https://apigateway.ambiente.gob.do/api/";
export const URL = "https://apigateway.ambiente.gob.do/api/sinap/"
//export const URL = "https://localhost:9001/api/";
export const URLEnviarPago = "https://apigateway.ambiente.gob.do/web/sinap/"
//export const Pagoprueba ="https://localhost:9001/web/"
// Para APIGATEWAY

export const DOCUMENT_TYPE = "https://apigateway.ambiente.gob.do/api/DocumentType";
export const NATIONALITY = "https://apigateway.ambiente.gob.do/api/Nationality";
export const LOGIN = "authApi/auth/login";
export const CLIENT = "https://apigateway.ambiente.gob.do/api/Client";
export const Reclamation = `${URL}Parque/reclamacion`;
export const CLIENT_INFO = "api/client/clientInfo";
export const VALIDATE = (documentTypeId, document) =>
  `https://apigateway.ambiente.gob.do/authApi/Auth/${documentTypeId}/${document}`;
export const VALIDDOCUMENT = (document) => `authApi/auth/${document}`;
export const CONFIRM_EMAIL = "https://apigateway.ambiente.gob.do/api/Client/ConfirmEmail";
export const REFRESH = "authApi/auth/refresh";
export const GETUSER = "api/client/getUser";
export const ENVIAR_PAGO = `${URLEnviarPago}EnviarPagoCarnet`;
export const ENVIAR_PAGO_GUEST = `${URLEnviarPago}EnviarPagoCarnetAnonymous`;
export const FACTURA_DETALLE = "api/facturaDetalle";
export const FACTURA = `${URL}Factura`;
export const CHANGEPASSWORD = "authApi/auth/changePassword";
//esta ul es correcta va a apigetaway
export const SERVICE_CLIENT = `${URLPago}ServiceClient`;
export const PERSONA_CEDULA = (document) =>
  `authApi/auth/personByCedula/${document}`;
//export const GET_HISTORIAL_COMPRAS = "https://localhost:9001/api/FacturaTransaccion/ObtenerBoletasCompradasUsuarioId";
//   export const URL = "https://localhost:9001/api/";
